import { render, staticRenderFns } from "./EtoroTrade.vue?vue&type=template&id=514eb009&scoped=true"
import script from "./EtoroTrade.vue?vue&type=script&lang=js"
export * from "./EtoroTrade.vue?vue&type=script&lang=js"
import style0 from "./EtoroTrade.vue?vue&type=style&index=0&id=514eb009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514eb009",
  null
  
)

export default component.exports